import React, { useEffect, useState } from 'react';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { WorkflowsDeleteIcon } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowsTable/WorkflowsRow/WorkflowsRowIcons';

export const DeleteWorkflowPopup = ({
  row = {} as Record<string, any>,
  onSubmit,
  disabled = false,
}) => {
  const [workflow, setWorkflow] = useState(row);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (row) {
      setWorkflow(row);
    }
  }, [row]);

  const submit = () => {
    onSubmit();
    setOpen(false);
  };

  const close = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger
          disabled={disabled}
          asChild
          onClick={(e) => e.stopPropagation()}
          className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
        >
          <WorkflowsDeleteIcon />
        </DialogTrigger>
        <DialogContent closeButtonHidden className={'overflow-hidden !max-w-[430px]'}>
          <DialogHeader>
            <DialogTitle className={'text-center text-sm font-bold text-ebony'}>
              Delete workflow
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-4">
            <div className="content">
              <div className="flex flex-col w-full">
                <div className={'flex flex-row gap-4 items-center'}>
                  <div>
                    <p className={'text-center text-ebony font-medium text-sm'}>
                      Are you sure you want to delete '{workflow.name}' workflow irretrievably?
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex justify-center mt-5">
                <div className="flex gap-2.5">
                  <Button variant="outline" type="button" className="min-w-24" onClick={close}>
                    Cancel
                  </Button>
                  <Button variant={'red'} onClick={submit} className="min-w-24">
                    Delete
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
